import { GET_PROFILE_API } from '../utils/api';

export const LOAD_PROFILE_REQUEST = '@profile/LOAD_PROFILE_REQUEST';
export const LOAD_PROFILE_SUCCESS = '@profile/LOAD_PROFILE_SUCCESS';
export const LOAD_PROFILE_FAILLURE = '@profile/LOAD_PROFILE_FAILLURE';
export const UPDATE_PROFILE = '@profile/UPDATE_PROFILE';

export function loadProfile() {
  return async (dispatch) => {
    try {
      dispatch({ type: LOAD_PROFILE_REQUEST });
      const response = await GET_PROFILE_API();
      dispatch({
        type: LOAD_PROFILE_SUCCESS,
        payload: {
          profile: response.data,
          status: response.status
        }
      });
      return response;
    } catch (error) {
      dispatch({
        type: LOAD_PROFILE_FAILLURE,
        payload: {
          error,
        }
      });
      return null;
    }
  };
}
